import {
  collection,
  getDocs,
  query,
  updateDoc,
  doc,
  getDoc,
  orderBy,
  limit,
  onSnapshot,
  setDoc,
} from "firebase/firestore"
import { complexRefv9 } from "src/services/complexServices"
import { complexRef } from '../complexServices';


const configRef = (id) => collection(complexRefv9(id), "conjuntoConfig")
const modulosRef = () => doc(complexRefv9(), "conjuntoConfig/Modulos")
const planillaRef = () => doc(complexRefv9(), "conjuntoConfig/PlanillaMensual")
const receivablesRef = (id) => complexRef(id).collection('conjuntoConfig')
const checkConfigRef = () => doc(complexRefv9(), "conjuntoConfig/NumeracionCheque")

export const getComplexConfig = async (id) => {
  try {
    const snap = await getDocs(query(configRef(id)))
    const data = snap.docs.map((snp) => ({ id: snp.id, ...snp.data() }))
    return data
  } catch (error) {
    throw Error(error)
  }
}

export const suscriberModules = (observer) => onSnapshot(modulosRef(), observer)
export const suscriberPlanillaMensual = (observer) => onSnapshot(planillaRef(), observer)
export const updateModules = (data) => updateDoc(modulosRef(), { IngresosEmail: data })
export const updateModulesFCP = (conjunto, data) => receivablesRef(conjunto).doc('Modulos').update(data)
export const getCheckModule = async () => {
  let checkNumSeq = 0
  let isEnableCheckSeq = false
  try {
    const isEnableCheckSeqDoc = await getDoc(checkConfigRef())

    if (isEnableCheckSeqDoc.exists()) {
      const { isCheckNumeration, checkNumeration = 0 } =
        isEnableCheckSeqDoc.data()
      isEnableCheckSeq = isCheckNumeration
      if (!checkNumeration) {
        const lastCheckRes = await getDocs(
          query(
            collection(complexRefv9(), "egresos"),
            orderBy("NumeroCheque", "desc"),
            limit(1)
          )
        )
        const lastCheckDoc = lastCheckRes.docs[0]
        if (lastCheckDoc?.exists()) {
          checkNumSeq = lastCheckDoc.data().NumeroCheque || 0
        }
      }
      checkNumSeq = checkNumeration || checkNumSeq
    }
    // por defecto retorna { 0, false }
    return {
      checkNumeration: checkNumSeq,
      isCheckNumeration: isEnableCheckSeq,
    }
  } catch (error) {
    return {
      checkNumeration: checkNumSeq,
      isCheckNumeration: isEnableCheckSeq,
    }
  }
}

export const updateCheckModule = (data) => setDoc(checkConfigRef(), data)
